/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"
import { Helmet } from "react-helmet"
import Header from "./header"
import { Col, Grid, Row } from "react-bootstrap"

const Layout = ({ children }) => {
  const strataPortalUrl = `${process.env.GATSBY_API_URL}strataLogin`
  const residentialPortalUrl = `${process.env.GATSBY_API_URL}login`

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <>
      <Helmet>
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"
            integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u"
            crossOrigin="anonymous" />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div className='margin-zero-auto'>
        <main>{children}</main>
      </div>
      <footer id="footer" className="custom-footer m-none">
        <Grid>
          <Row>
            <Col md={3} mdOffset={1}>
              <h5 className="text-color-light font-weight-bold mb-xs">Strata</h5>
              <ul>
                <li>
                  <Link to="/strata" className="text-color-light" title="Property Management">
                    Property Management
                  </Link>
                </li>
                <li>
                  <Link to="/strata/documents" className="text-color-light" title="forms">
                    Forms
                  </Link>
                </li>
                <li>
                  <Link to={strataPortalUrl} className="text-color-light" title="Login">
                    Login
                  </Link>
                </li>
              </ul>
            </Col>
            <Col md={3} mdOffset={1}>
              <h5 className="text-color-light font-weight-bold mb-xs">Company</h5>
              <ul>
                <li>
                  <Link to="/company" className="text-color-light">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-color-light">
                    Contact
                  </Link>
                </li>
              </ul>
            </Col>
            <Col md={3} mdOffset={1}>
              <h5 className="text-color-light font-weight-bold mb-xs">Residential</h5>
              <ul>
                <li>
                  <Link to="/residential" className="text-color-light" title="Property Management">
                    Property Management
                  </Link>
                </li>
                <li>
                  <Link to="/listings" className="text-color-light" title="Rental Listings">
                    Rental Listings
                  </Link>
                </li>
                <li>
                  <Link to={residentialPortalUrl} className="text-color-light" title="Login">
                    Login
                  </Link>
                </li>
              </ul>
            </Col>
            <Col md={2}>
            </Col>
          </Row>
        </Grid>
        <div className="footer-copyright m-none pt-md pb-md">
          <Grid>
            <Row>
              <Col md={12} className="pt-md center">
                <p className="custom-text-color-2">&copy; Copyright 2018 Korecki Real Estate Services Inc. All Rights Reserved.</p>
              </Col>
            </Row>
          </Grid>
        </div>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
